import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../../../Common/CLabel'
import { useTranslation } from "react-i18next";
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import PropTypes from 'prop-types';
import '../../../../../../styles/css/Card.css'
import './style-card.css'

function BusinessElementCard(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
        inputParam_EditMode = false,
        inputParam_SelectedElementId = null,
        inputParam_ElementItem = null,
        inputParam_CompactMode = null,
        
    } = props;

    


    return (
        <>
            <Card className={`${inputParam_SelectedElementId === inputParam_ElementItem.elementId ? "selected-card" : ""}`} style={{ fontSize: "13px", borderLeft: `20px solid ${ inputParam_ElementItem.htmlColor !== null && inputParam_ElementItem.htmlColor !== undefined ? inputParam_ElementItem.htmlColor : "" }` }}>
                <Card.Body style={{backgroundColor: "#79AFFF", height: inputParam_CompactMode ? "auto !important" : ""}} className="card-board p-0 m-0 ps-1">
                    <Row style={{cursor: inputParam_ElementItem.id !== 0 ? "pointer" : "default" }} >
                        <Col xl={12} className="card-board-body">
                            <TooltipHost content={ inputParam_ElementItem.name } overflowMode={TooltipOverflowMode.Parent} >
                                <div>
                                    {
                                        inputParam_CompactMode === false ? <h4><b>{ inputParam_ElementItem.name }</b></h4> : <h6><b>{ inputParam_ElementItem.name }</b></h6>
                                    }
                                </div>
                            </TooltipHost>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Body className="card-board p-0 m-0 ps-1">
                    <Row style={{cursor: inputParam_ElementItem.id !== 0 ? "pointer" : "default" }} >
                        <Col xl={12} className="card-board-body">
                            <Row>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-code') } labelValue={ inputParam_ElementItem.code } />
                                </Col>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-type') } labelValue={ t(inputParam_ElementItem.type) } />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
                    
            </Card>
        </>
    );
}

///Proptypes
BusinessElementCard.propTypes = {
    inputParam_GAPId: PropTypes.number.isRequired,
    inputParam_SelectedElementId: PropTypes.number,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ElementItem: PropTypes.object,
    inputParam_SetterGAPElements: PropTypes.func,
    inputParam_CompactMode: PropTypes.bool.isRequired,
};

export default BusinessElementCard;